export default __webpack_public_path__ + "static/media/118.00f31fa8.png";